module.exports = __webpack_public_path__ + "static/media/bord-gais-energy.6418c3d4.jpg";